import { types } from 'mobx-state-tree';

const FormFieldType = {
  BOOLEAN: 'BOOLEAN',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  SELECT: 'SELECT',
  TEXT: 'TEXT',
  TEXTAREA: 'TEXTAREA',
  BUTTON: 'BUTTON',
  SEARCH: 'SEARCH',
  FILE: 'FILE',
};

export default FormFieldType;

export const FormFieldTypeType = types.enumeration(
  'FormFieldTypeType',
  Object.values(FormFieldType)
);
